<script>
    import PlaygroundRating from '../../PlaygroundRating.svelte';
    import CopyButton from '../../CopyButton.svelte';
    import PlaygroundHelper from '../../scripts/playgroundhelper';

    export let playground;

    export let showRating = true;
</script>

<h3>{PlaygroundHelper.presentPlayground(playground, false)}</h3>
<span class="subtitle">
    {#if playground.municipality}
        {playground.municipality}
    {/if}

    {#if playground._id}
        <!-- The separator goes with the id, so that hiding it on a phone doesn't leave a
             dot hanging off the end of the municipality -->
        <span class="id-text">{#if playground.municipality}· {/if}{playground._id}</span>
        <CopyButton text={playground._id} title="Kopiera ID" />
        <CopyButton text={PlaygroundHelper.getPlaygroundUrl(playground)} iconClass="fas fa-link" title="Kopiera länk" />
    {/if}
</span>

{#if showRating}
    <PlaygroundRating {playground} />
{/if}

<style>
    h3 {
        margin-bottom: 0;
    }

    .subtitle {
        color: silver;
        padding: 0;
        margin: 0;
    }
</style>
